<template>
  <div>
    <form>
      <div class="form-inline">
        <input type="text" class="form-control col-auto" v-model="searchText" placeholder="Search for a game" />
        <div class="form-group">
          <label for="sortDropdown" class="col-auto">Sort By:</label>
          <select name="sortDropdown" class="form-control col-auto" v-model="sortDropdown">
              <option value="submitTime">Submitted time</option>
              <option value="name">Name</option>
              <option value="metacritic">Metacritic Score</option>
          </select>
        </div>
        <div @click="toggleShowRedeemed" class="col-auto">
          <button type="button" class="btn btn-outline-secondary form-control" v-if="!showRedeemed">Show redeemed keys only</button>
          <button type="button" class="btn btn-outline-secondary form-control" v-if="showRedeemed">Show unredeemed keys only</button>
        </div>
        <div class="form-group">
          <label for="genreDropdown" class="col-auto">Filter Genre:</label>
          <select name="genreDropdown" class="form-control col-auto" v-model="genreDropdown">
              <option value="noFilter">No filter</option>
              <option v-for="genre in genreList" :value="genre" v-bind:key="genre">{{ genre }}</option>
          </select>
        </div>
      </div>
    </form>
    <div v-if="!$apollo.loading && !gamesList.keys.length">
      <h2>Couldn't find any games, sorry fam</h2>
    </div>
    <div v-if="gamesList.keys.length">
      <div class="table-responsive">
        <table class="table table-sm table-hover table-striped">
          <thead>
            <tr>
              <th scope="col">Game Name</th>
              <th scope="col">Genre</th>
              <th scope="col">Metacritic</th>
              <th scope="col">DLCs</th>
              <th scope="col">Submitter</th>
              <th scope="col">Submitted</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="game in sortedArray(filteredList, sortDropdown)" :key="game.KeyId" :game="game">
              <td>
                <router-link tag="a" :to="'/game/' + game.KeyId">
                  <a class="nav-link">{{ game.name }}</a>
                </router-link>
              </td>
              <td><p v-if="game.genres">{{ game.genres }}</p></td>
              <td><p v-if="game.metacritic">{{ game.metacritic }}</p></td>
              <td><p v-if="game.dlcs">{{ game.dlcs.length }} DLCs</p></td>
              <td>{{ game.submitter }}</td>
              <td>{{ game.submitTime | moment("from", "now") }}</td>
            </tr>
          </tbody>
        </table>
        <div>
          <button v-if="gamesList.nextToken" @click="showMore">Show more</button>
        </div>
      </div>
    </div>
    <h4 v-if="$apollo.loading">Loading...</h4>
  </div>
</template>

<script>
import gql from 'graphql-tag'

const pageSize = 1000;

export default {
  name: "GameList",
  data() {
    return {
      gamesList: {
        keys: [],
        nextToken: null
      },
      searchText: '',
      sortDropdown: 'submitTime',
      showRedeemed: false,
      genreList: [],
      genreDropdown: 'noFilter'
    };
  },
  apollo: {
    gamesList: {
      query: gql`query listKeys ($limit: Int, $nextToken: String, $includeRedeemed: Boolean) {
        gamesList: listKeys(limit: $limit, nextToken: $nextToken, includeRedeemed: $includeRedeemed) {
          nextToken
          keys {
            KeyId
            name
            notes
            genres
            metacritic
            released
            submitter
            submitTime
            redeemed
            dlcs {
              name
              notes
            }
          }
        }
      }`,
      variables: {
        limit: pageSize,
        includeRedeemed: false
      },
      result() {
        // Abuse a hash map to get a list of unique genres of all options
        var genreMap = {}

        this.gamesList.keys.forEach(key => {
          if (key.genres) {
            // Split each key's genres on comma then add it to the map
            key.genres.split(', ').map(genre => genreMap[genre] = true)
          }
        })

        // Map should now contain unique list of genres
        this.genreList = Object.keys(genreMap).sort()
      }
    }
  },
  methods: {
    showMore () {
      this.$apollo.queries.gamesList.fetchMore({
        variables() {
          return {
            limit: pageSize,
            nextToken: this.gamesList.nextToken,
            includeRedeemed: this.showRedeemed
          }
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return {
            gamesList: {
              __typename: previousResult.gamesList.__typename,
              // Merging the key list
              keys: [...previousResult.gamesList.keys, ...fetchMoreResult.gamesList.keys],
              nextToken: fetchMoreResult.gamesList.nextToken
            }
          }
        }
      })
    },
    toggleShowRedeemed () {
      this.showRedeemed = !this.showRedeemed
      this.nextToken = null
      // Refetch list
      this.$apollo.queries.gamesList.refetch({
        limit: pageSize,
        nextToken: null,
        includeRedeemed: this.showRedeemed
      })
    },
    sortedArray (array, sortKey) {
      function compare(a, b) {
        if (a[sortKey] < b[sortKey])
          return -1;
        if (a[sortKey] > b[sortKey])
          return 1;
        return 0;
      }
      function compareInverted(a, b) {
        if (a[sortKey] > b[sortKey])
          return -1;
        if (a[sortKey] < b[sortKey])
          return 1;
        return 0;
      }
      if (sortKey == 'name') {
        return [...array].sort(compare);
      } else if (sortKey == 'submitTime' || sortKey == 'metacritic') {
        return [...array].sort(compareInverted);
      }
      // Catch all
      return [...array].sort(compare);
    },
    filterOnSearchString(list) {
      if(this.searchText.length) {
        return list.filter((item) => {
          return item.name.toLowerCase().includes(this.searchText.toLowerCase())
        })
      } else {
        return list
      }
    },
    filterOnGenre(list) {
      if(this.genreDropdown != 'noFilter') {
        return list.filter((item) => {
          return item.hasOwnProperty('genres') && item.genres.includes(this.genreDropdown)
        })
      } else {
        return list
      }
    }
  },
  computed: {
    filteredList(){
      return this.filterOnGenre(this.filterOnSearchString(this.gamesList.keys))
    }
  }
};
</script>